export default __webpack_public_path__ + "static/media/CongoPopper.7797ec17.svg";